export type TTranslatedUrl = Record<string, Record<string, string>>;

export const TRANSLATED_URLS: TTranslatedUrl = {
  // 'card-payments': {
  //   de: 'kartenzahlung',
  //   bg: 'plashtane-s-karta',
  //   ro: 'plati-cu-cardul',
  // },
  'payment-link': {
    nl: 'betaallink',
    ro: 'link-de-plata',
  },
  'customer-lifetime-value-prediction': {
    de: 'datenanreicherung',
  },
};
